import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { NavigationExtras, Router } from '@angular/router';
import firebase from 'firebase/app';
import 'firebase/firestore';
import { Observable } from 'rxjs';
import { Estudiante } from 'src/app/core/clases/estudiante.model';
import { InscripcionService } from '../services/inscripcion/inscripcion.service';
import { CursosService } from '../services/cursos/cursos.service';
import { TutorService } from '../services/tutor/tutor.service';
import { CodeService } from '../services/codes/code.service';



@Component({
  selector: 'app-firebase-auth',
  templateUrl: './firebase-auth.component.html',
  styleUrls: ['./firebase-auth.component.scss']
})
export class FirebaseAuthComponent implements OnInit {

  error = null;

  constructor(private afAuth: AngularFireAuth,
    private firestore: AngularFirestore,
    private router: Router,
    private inscripcionService: InscripcionService,
    private cursosService: CursosService,
    private tutorService: TutorService,
    private codeService: CodeService) {

  }

  ngOnInit(): void {
  }

  public async login(email: string, password: string): Promise<any> {
    try {
      const resp = await this.afAuth.signInWithEmailAndPassword(email, password);
      const uid = resp.user.uid;
      this.router.navigate([`/profile/${uid}`, { from: 'login' }]);
      return 'success';
    } catch (e) {
      console.log(e.message);
      this.error = e.message;
      return Promise.reject(this.error);
    }
  }
  public async loginAfterCreate(email: string, password: string): Promise<any> {

    await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
      .then(() => {
        // Existing and future Auth states are now persisted in the current
        // session only. Closing the window would clear any existing state even
        // if a user forgets to sign out.
        // ...
        // New sign-in will be persisted with session persistence.
        return firebase.auth().signInWithEmailAndPassword(email, password);
      }).catch((error) => {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
      });
  }



  async createUser(user: any, alumnos: Estudiante[]): Promise<any> {
    try {
      const email = user.email;
      const password = user.password;
      const firstName = user.nombre;
      const lastName = user.apellido;
      const resp = await this.afAuth.createUserWithEmailAndPassword(email, password);
      //this.loginAfterCreate(email, password);
      await resp.user.updateProfile({ displayName: `${firstName} ${lastName}` });
      await this.savedUserBD(resp.user.uid, user, alumnos);
      console.log(resp.user.uid);
      return resp.user.uid;

    } catch (e) {
      console.log(e.message);
      this.error = e.message;
      throw e;
    }
  }

  async savedUserBD(userId: any, user: any, alumnos: Estudiante[]): Promise<any> {
    user.idUserAuth = userId;
    user.fullname = user.firstname + ' ' + user.lastname;
    user.idUserAuth = userId;
    this.firestore.collection('users').doc(userId).set(Object.assign({}, user)).then(res => {
    }).catch(e => {
      console.log(e);
    });
    const refDoc = this.firestore.collection('users').ref;
    alumnos.forEach(async element => {
      const idAlum = (Date.now().toString(36) + Math.random().toString(36).substr(2, 22));
      element.userType = 'student';
      element.showStudent = false;
      element.tutor = [];
      element.tutor.push((await refDoc.doc(userId).get()).ref);
      element.fullname = element.firstname + ' ' + element.lastname;
      element.sexo = element.sexo.toLowerCase();
      await this.firestore.collection('users').doc(idAlum).set(Object.assign({}, element)).then(async res => {
      });
      const tutorRef = this.firestore.collection('users').doc(userId);
      tutorRef.update({
        alumns: firebase.firestore.FieldValue.arrayUnion((await refDoc.doc(idAlum).get()).ref)
      }).then(() => {
        this.inscripcionService.insertarIncripcion(element, user, idAlum, userId).catch(
          (error) => {
            console.log('fallo la inscripcion ' + error);
          }
        );
      }).catch((error) => {
        console.log('fallo la creacion de alumno ' + element + '  error ' + error)
      });
    }
    );
  }

  public getUser(): Observable<any> {
    return this.afAuth.user;
  }

  public logout(): void {
    this.afAuth.signOut().then(() => {
      const navigationExtras: NavigationExtras = {
        queryParams: { logout: true },
      };
      this.router.navigate(['/'], navigationExtras);
    });
  }

  public async crearAlumno(alumno, tutor): Promise<any> {
    await this.firestore.collection('users').doc(alumno.id).set(Object.assign({}, alumno)).then(async res => {
    });
    const tutorRef = this.firestore.collection('users').doc(tutor.id);
    tutorRef.update({
      alumns: firebase.firestore.FieldValue.arrayUnion(firebase.firestore().doc(`/users/${alumno.id}`))
    }).then(() => {
      this.inscripcionService.insertarIncripcion(alumno, tutor, alumno.id, tutor.id).catch(
        (error) => {
          console.log('fallo la inscripcion ' + error);
        }
      );
    }).catch((error) => {
      console.log('fallo la creacion de alumno ' + alumno + '  error ' + error);
      throw error;
    });

  }

  eliminarInscripcionesAlumnos(alumnos: Array<any>): void {
    try {
      console.log(alumnos);
      alumnos.forEach(alumno => {
        if (alumno.status != 'matriculado' && alumno.status != 'test' && alumno.status != 'espera'){
          this.eliminarYLimpiarInscripcion(alumno);
        }
      });
    } catch (error) {
      console.log('verificar borrado');
    }
  }

  eliminarYLimpiarInscripcion(alumno): void {
    alumno.areaInterest = null;
    alumno.municipio = null;
    alumno.centro = null;
    alumno.dia = null;
    alumno.horaCursoSeleccionada = null;
    if (alumno.status == 'espera') {
      this.eliminarDeListaEspera(alumno);
      alumno.cursoElegido = null;
    } else {
      this.consultarCuposGrupoAEliminar(alumno);
    }
  }


  consultarCuposGrupoAEliminar(alumno): void {
    const idCurso = alumno.courses[0].id;
    // tslint:disable-next-line: deprecation
    this.cursosService.getCurso(idCurso).subscribe(res => {
      const curso: any = res.data();
      const cuposActuales = curso.high - 1;
      this.eliminarReserva(alumno, idCurso, cuposActuales);
    });

  }
  eliminarDeListaEspera(alumno): void {
    // tslint:disable-next-line: deprecation
    this.inscripcionService.obtenerInscripcionPorAlumno(alumno.id).subscribe(res => {
      const inscripcionId = res.docs[0].id;
      alumno.inscripcionId = inscripcionId;
      this.inscripcionService.eliminarInscripcion(inscripcionId).then(() => {
        this.tutorService.updateUserStatus(alumno.id, 'prospectivo').then(() => {
          alumno.listaEspera = false;
        }).catch((error) => {
          console.log('error al eliminar de la lista de espera ' + error);
        });
      });
    });
  }
  eliminarReserva(alumno, idCurso, cuposActuales): void {
    this.inscripcionService.eliminarInscripcion(alumno.inscripcionId).then(() => {
      this.cursosService.establecerPlazaCurso(idCurso, cuposActuales).then(() => {
        this.tutorService.eliminarUserInfoAcademicaAlumno(alumno).then(() => {
          alumno.cursoElegido = null;
          alumno.inscripcionId = null;
          if (alumno.codePromocionalId != null && alumno.codePromocionalId != '') {
            this.actualizarCodigo(alumno.codePromocionalId, 'No usado');
          }
        }).catch((error) => {
          console.log('error al borrar la info academica ' + error);
        });
      }).catch((error) => {
        console.log('error al restituir la plaza del curso ' + error);
      });
    }).catch((error) => {
      console.log('error al eliminar la inscripcion del alumno ' + error);
    });
  }
  actualizarCodigo(idCode, status): void {
    this.codeService.updateCodeStatus(idCode, status).then(() => {
    }).catch((error) => {
      console.log('error al actualizar el estado del codigo promocional  ' + error);
    });
  }
}
